import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"

export default function BNGWorldCup({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const data = promotionsData.find(
    (promo) => promo.title === "BNG World Cup Fortune Race"
  )
  const [isMobile, setIsMobile] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> BNG World Cup Fortune Race </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>{" "}
              / <span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1> BNG World Cup Fortune Race </h1>
                  <h2> Total Prize Pool ₱3,575,000 </h2>
                  <div className="promotion-tnc-period">
                    <strong> Event Period </strong>
                    <span> June 05 (12PM) - July 19 (12PM) </span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong> Campaign Details </strong>
                  <ol>
                    <li>
                      <strong className="highlight">
                        Games Participating:{" "}
                      </strong>
                      All BNG games.
                    </li>
                    <li>
                      <strong className="highlight">Period: </strong>{" "}
                      <ul>
                        <li>
                          <strong className="highlight">
                            Week 1 (Multiplier race)
                          </strong>
                          : 2026.06.05 12:00 P.M ~ 2026.06.11 12:00 P.M UTC+8
                        </li>
                        <li>
                          <strong className="highlight">
                            Week 2 (Bet race)
                          </strong>
                          : 2026.06.12 12:00 P.M ~ 2026.06. 18 12:00 P.M UTC+8
                        </li>
                        <li>
                          <strong className="highlight">
                            Week 3 (Multiplier race)
                          </strong>
                          : 2026.06.19 12:00 P.M ~ 2026.06.25 12:00 P.M UTC+8
                        </li>
                        <li>
                          <strong className="highlight">
                            Week 4 (Bet race)
                          </strong>
                          : 2026.06.26 12:00 P.M ~ 2026.07.02 12:00 P.M UTC+8
                        </li>
                        <li>
                          <strong className="highlight">
                            Week 5 (Multiplier race)
                          </strong>
                          : 2026.07.03 12:00 P.M ~ 2026.07.09 12:00 P.M UTC+8
                        </li>
                        <li>
                          <strong className="highlight">
                            week 6 (Bet race)
                          </strong>
                          : 2026.07.03 12:00 P.M ~ 2026.07.09 12:00 P.M UTC+8
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong className="highlight">Qualification: </strong>
                      Play at BNG games for at least 1 rounds with minimum 0.55
                      PHP bet
                    </li>
                  </ol>
                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <tr>
                          <th colSpan={3}>Week 1 - Week 5</th>
                        </tr>
                        <tr>
                          <th>Rank</th>
                          <th>Prize</th>
                          <th>Currency</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1st</td>
                          <td>55,000</td>
                          <td rowSpan={10}>PHP</td>
                        </tr>
                        <tr>
                          <td>2nd</td>
                          <td>44,000</td>
                        </tr>
                        <tr>
                          <td>3rd</td>
                          <td>27,500</td>
                        </tr>
                        <tr>
                          <td>4th - 5th</td>
                          <td>16,500</td>
                        </tr>
                        <tr>
                          <td>6th - 10th</td>
                          <td>11,000</td>
                        </tr>
                        <tr>
                          <td>11th - 20th</td>
                          <td>5,500</td>
                        </tr>
                        <tr>
                          <td>21th - 50th</td>
                          <td>3,850</td>
                        </tr>
                        <tr>
                          <td>51th - 100th</td>
                          <td>1,650</td>
                        </tr>
                        <tr>
                          <td>101th - 200th</td>
                          <td>550</td>
                        </tr>
                        <tr>
                          <td>201th - 300th</td>
                          <td>275</td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <tr>
                          <th colSpan={3}>Week 6 Prize Table</th>
                        </tr>
                        <tr>
                          <th>Rank</th>
                          <th>Prize</th>
                          <th>Currency</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>1st</td>
                          <td>66,000</td>
                          <td rowSpan={11}>PHP</td>
                        </tr>
                        <tr>
                          <td>2nd</td>
                          <td>55,000</td>
                        </tr>
                        <tr>
                          <td>3rd</td>
                          <td>38,500</td>
                        </tr>
                        <tr>
                          <td>4th - 5th</td>
                          <td>27,500</td>
                        </tr>
                        <tr>
                          <td>6th - 10th</td>
                          <td>16,500</td>
                        </tr>
                        <tr>
                          <td>11th - 20th</td>
                          <td>5,500</td>
                        </tr>
                        <tr>
                          <td>21th - 50th</td>
                          <td>3,850</td>
                        </tr>
                        <tr>
                          <td>51th - 100th</td>
                          <td>2,750</td>
                        </tr>
                        <tr>
                          <td>101th - 150th</td>
                          <td>1,650</td>
                        </tr>
                        <tr>
                          <td>151th - 300th</td>
                          <td>550</td>
                        </tr>
                        <tr>
                          <td>301th - 500th</td>
                          <td>275</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <strong>Terms & Conditions</strong>
                  <ol>
                    <li>All time mentioned above is based on UTC+8.</li>
                    <li>
                      Once the player meets the leaderboard requirements, the
                      wins earned in previous qualified rounds during the
                      tournament will be converted into points.
                    </li>
                    <li>
                      The value of points will be rounded off to 2 decimal
                      places when calculating points.
                    </li>
                    <li>Only qualified rounds are counted in this campaign.</li>
                    <li>
                      All prizes and bets in the campaign become invalid if any
                      malfunction occurs.
                    </li>
                    <li>
                      Anyone who participates in this campaign is deemed to
                      agree with all the regulations of the campaign and the
                      casino, and is willing to abide by it, The organizer
                      reserves the right to modify and terminate this campaign
                      at any time.
                    </li>
                    <li>
                      Winners are able to claim their prizes in each
                      campaign-designated game by clicking the collect button on
                      the pop-up message after the campaign finishes. Please be
                      aware of the change in your account balance.
                    </li>
                  </ol>
                  <div className="promotion-tnc-cta">
                    <a
                      className="promotion-cta-btn"
                      href="https://servicebooongo.com//bngevent/event?event=2026worldcup&lang=en&currency=PHP"
                      target="_blank"
                      rel="noreferrer"
                    >
                      View Full T&C
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
